import mitt from "mitt";

const emitter = mitt();
const calledQueue = new Map();

const isDevelopment = process.env.NODE_ENV === "development";

export function setupEmitter(debugEvents = false) {
  if (debugEvents) emitter.on("*", (type, e) => console.log(type, e));

  emitter.on("*", (type, ev) => {
    calledQueue.set(type, ev);
  });

  return emitter;
}

export function addHandler(type, handler, callUnregisteredHandler = false) {
  emitter.on(type, handler);

  // if (callUnregisteredHandler && calledQueue.has(type)) {
  //   if (isDevelopment)
  //     console.warn("CALLING UNREGISTERED HANDLER FOR EVENT:", type);
  //   // calledQueue.delete(type);
  //   handler();
  // }
}

export function removeHandler(type, handler) {
  emitter.off(type, handler);
  calledQueue.delete(type);
}

export default emitter;
